/**
 * 부동산 금액을 한국식으로 표시 (만원 단위 → 억/만 변환)
 * 예: 32000 → "3억 2,000만"
 */
export function formatPrice(manwon: number): string {
  if (manwon >= 10000) {
    const eok = Math.floor(manwon / 10000);
    const remainder = manwon % 10000;
    if (remainder === 0) return `${eok}억`;
    return `${eok}억 ${remainder.toLocaleString()}만`;
  }
  return `${manwon.toLocaleString()}만`;
}

/**
 * 면적을 평 + m² 병기로 표시
 * 예: 500 → "500평 (1,653m²)"
 */
export function formatArea(pyeong: number): string {
  const sqm = Math.round(pyeong * 3.3058);
  return `${pyeong.toLocaleString()}평 (${sqm.toLocaleString()}m\u00B2)`;
}

/**
 * 전화번호 포맷
 * 예: "01012345678" → "010-1234-5678"
 */
export function formatPhone(phone: string): string {
  const cleaned = phone.replace(/\D/g, "");
  if (cleaned.length === 11) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`;
  }
  if (cleaned.length === 10) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  return phone;
}

/**
 * 신뢰도 점수 라벨
 */
export function trustLabel(score: number): string {
  if (score >= 80) return "우수";
  if (score >= 60) return "양호";
  if (score >= 40) return "보통";
  if (score >= 20) return "주의";
  return "경고";
}

/**
 * 신뢰도 점수 색상
 */
export function trustColor(score: number): string {
  if (score >= 80) return "#10B981";
  if (score >= 60) return "#3B82F6";
  if (score >= 40) return "#F59E0B";
  if (score >= 20) return "#F97316";
  return "#EF4444";
}
